// Static Service Module Map
// ✅ NO DYNAMIC IMPORTS: All service modules are statically imported so Vite
// can analyse them at build time. Add a new entry here whenever you add a
// new service to public/config/services.config.yml.

import * as ApplicationApiModule from "src/domains/application/module/api/applicationApi";
import * as AuthServiceModule from "src/domains/auth/services/authService";
import * as ValidationServiceModule from "src/domains/auth/services/validationService";
import * as ProjectApiModule from "src/domains/project/module/api/projectApi";
import * as ProjectServiceModule from "src/domains/project/services/project";
import * as QuickStartServiceModule from "src/domains/project/services/quickstart";
import * as UserApiServiceModule from "src/domains/user/services/api";
import * as DataManagerModule from "src/platform/data/DataManager";
import * as ErrorHandlerModule from "src/platform/error/ErrorHandler";
import * as EventBusModule from "src/platform/events/EventBus";
import * as ContextToEventAdapterModule from "src/platform/integration/adapters/ContextToEventAdapter";
import * as CrossModuleIntegrationModule from "src/platform/integration/CrossModuleIntegration";
import * as AppOrchestratorModule from "src/platform/orchestrator/AppOrchestrator";

/**
 * Maps the `module` string from services.config.yml to its statically-imported module.
 * Keys must match the `module` field in services.config.yml exactly.
 *
 * When adding a new service:
 * 1. Add a static import above
 * 2. Add the map entry below (key = module string from services.config.yml)
 */
export const SERVICE_MODULE_MAP: Record<string, Record<string, unknown>> = {
  "platform/events/EventBus": EventBusModule as Record<string, unknown>,
  "platform/data/DataManager": DataManagerModule as Record<string, unknown>,
  "platform/error/ErrorHandler": ErrorHandlerModule as Record<string, unknown>,
  "platform/orchestrator/AppOrchestrator": AppOrchestratorModule as Record<
    string,
    unknown
  >,
  "platform/integration/adapters/ContextToEventAdapter":
    ContextToEventAdapterModule as Record<string, unknown>,
  "platform/integration/CrossModuleIntegration":
    CrossModuleIntegrationModule as Record<string, unknown>,
  "domains/auth/services/authService": AuthServiceModule as Record<
    string,
    unknown
  >,
  "domains/application/module/api/applicationApi":
    ApplicationApiModule as Record<string, unknown>,
  "domains/project/module/api/projectApi": ProjectApiModule as Record<
    string,
    unknown
  >,
  "domains/auth/services/validationService": ValidationServiceModule as Record<
    string,
    unknown
  >,
  "domains/project/services/project": ProjectServiceModule as Record<
    string,
    unknown
  >,
  "domains/project/services/quickstart": QuickStartServiceModule as Record<
    string,
    unknown
  >,
  "domains/user/services/api": UserApiServiceModule as Record<string, unknown>,
};
